import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import { openCodeEditor } from '../../actions/codeEditor';
import { ROUTE_LOGOUT } from '../../api/routes';
import {
  openBaseModuleView,
  changeBaseModuleScreen,
} from '../../actions/baseModule';
import i18n from '../../internationalization/i18n';
import Icon from '../Icon/Icon';

const actionLinkClasses = 'o-bb-menu__item';
const propTypes = {
  openBaseModuleView: PropTypes.func.isRequired,
  changeBaseModuleScreen: PropTypes.func.isRequired,
  enabledModules: PropTypes.array.isRequired,
  isSuperAdmin: PropTypes.bool.isRequired,
};

class ConfigurationContainer extends React.Component {
  static propTypes = {
    openCodeEditor: PropTypes.func.isRequired,
  };

  showCssEditor = () => {
    this.props.openCodeEditor('css');
  };

  showJsEditor = () => {
    this.props.openCodeEditor('js');
  };

  showBaseModule = () => {
    this.props.openBaseModuleView();
    this.props.changeBaseModuleScreen('overview');
  };

  showBaseModuleList = () => {
    this.props.openBaseModuleView();
    this.props.changeBaseModuleScreen('items');
  };

  render() {
    const baseModuleMenuItems = [];

    if (this.props.enabledModules.includes('base_module')) {
      if (this.props.isSuperAdmin) {
        baseModuleMenuItems.push(
          <li className={actionLinkClasses} key="base_module">
            <div onClick={this.showBaseModule}><i className="icon-password" />{i18n.t('CONTENT.baseModule')}</div>
          </li>,
        );
      }

      baseModuleMenuItems.push(
        <li className={`${actionLinkClasses}--spacing ${actionLinkClasses}`} key="base_module_items">
          <div onClick={this.showBaseModuleList}><i className="icon-password" />{i18n.t('CONTENT.baseModuleItems')}</div>
        </li>,
      );
    }

    return (
      <ul className="o-bb-menu">
        <li key="3" className={`${actionLinkClasses} o-bb-menu__item--not-active`}><i className="icon-my-profile" />{i18n.t('CONTENT.yourProfile')}</li>
        <li key="4" className={`${actionLinkClasses}--spacing ${actionLinkClasses} o-bb-menu__item--not-active`}><i className="icon-password" />{i18n.t('CONTENT.changePassword')}</li>
        { baseModuleMenuItems }
        <li key="5" className={actionLinkClasses}>
          <div onClick={this.showCssEditor}>
            <Icon name="code-transparent" className="o-bb-menu__item__code-icon" />
            {i18n.t('CONTENT.cssEditor')}
          </div>
        </li>
        <li key="6" className={`${actionLinkClasses}--spacing ${actionLinkClasses}`}>
          <div onClick={this.showJsEditor}>
            <Icon name="code-transparent" className="o-bb-menu__item__code-icon" />
            {i18n.t('CONTENT.jsEditor')}
          </div>
        </li>
        <li className={actionLinkClasses}><a className={actionLinkClasses} href={ROUTE_LOGOUT}><i className="icon-logout" />{i18n.t('CONTENT.logout')}</a></li>
      </ul>
    );
  }
}

ConfigurationContainer.propTypes = propTypes;

const mapStateToProps = (state) => {
  const {
    pages: {
      settings: {
        isSuperAdmin,
      },
    },
    global: {
      websiteSettings: {
        enabledModules,
      },
    },
  } = state;

  return {
    enabledModules,
    isSuperAdmin,
  };
};

const mapDispatchToProps = {
  openBaseModuleView,
  changeBaseModuleScreen,
  openCodeEditor,
};

export default withNamespaces()(connect(mapStateToProps, mapDispatchToProps)(ConfigurationContainer));



// WEBPACK FOOTER //
// ./src/components/Configuration/ConfigurationContainer.js